/* ==========================================================================
   HUMO BARRILES · AJUSTES DE LA ENTRADA
   assets/humo-hero-ajustes.js
   ========================================================================== */
(function () {
  'use strict';

  var CON_ANCLA = !!window.location.hash;
  var PLANETA_ESCRITORIO = { x: -0.05, y: 0.50, alturaFrac: 0.88 };
  var RETENCION = 1400;

  var AVISO = {
    en: 'Scroll to see what\u2019s happening',
    es: 'Desliza para ver qu\u00e9 est\u00e1 pasando'
  };

  function movil() {
    return window.matchMedia('(max-width: 900px), (orientation: portrait) and (max-width: 1024px)').matches;
  }

  /* ======================================================================
     AVISOS DE DESPLAZAMIENTO
     El motor reescribe los textos marcados con data-hb-t al cambiar de
     idioma. Se le quita esa marca y la traducción la lleva este archivo.
     ====================================================================== */
  function pintarAvisos(sec) {
    var lang = sec.getAttribute('data-lang') === 'es' ? 'es' : 'en';
    var marcas = sec.querySelectorAll('[data-hb-aviso]');
    for (var i = 0; i < marcas.length; i++) marcas[i].textContent = AVISO[lang];
  }

  function montarAvisos() {
    var sec = document.getElementById('humo-hero');
    if (!sec || sec.dataset.avisoListo === '1') return !!sec;

    var cue = sec.querySelector('.hb-hero__cue');
    if (!cue) return false;
    sec.dataset.avisoListo = '1';

    var txt = cue.querySelector('[data-hb-t="cue"]') || cue.querySelector('span');
    if (txt) {
      txt.removeAttribute('data-hb-t');
      txt.setAttribute('data-hb-aviso', '');
    }

    /* copia para la intro, sobre el planeta girando con el sello */
    var copia = cue.cloneNode(true);
    copia.classList.add('hb-hero__cue--intro');
    copia.removeAttribute('id');
    copia.setAttribute('aria-hidden', 'true');
    copia.setAttribute('tabindex', '-1');
    var t2 = copia.querySelector('span');
    if (t2) { t2.removeAttribute('data-hb-t'); t2.setAttribute('data-hb-aviso', ''); }
    sec.appendChild(copia);

    pintarAvisos(sec);

    new MutationObserver(function () { pintarAvisos(sec); })
      .observe(sec, { attributes: true, attributeFilter: ['data-lang'] });

    /* el aviso de la intro se retira en cuanto el visitante baja */
    function revisar() {
      sec.setAttribute('data-andando', window.pageYOffset > 40 ? 'si' : 'no');
    }
    revisar();
    window.addEventListener('scroll', revisar, { passive: true });

    return true;
  }

  if (!montarAvisos()) {
    var n = 0;
    var relojAviso = setInterval(function () {
      n++;
      if (montarAvisos() || n > 80) clearInterval(relojAviso);
    }, 120);
  }

  /* ======================================================================
     ARRANCAR SIEMPRE ARRIBA
     ====================================================================== */
  if (!CON_ANCLA) {
    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';

    function limpiarMemoria() {
      if (window.ScrollTrigger && typeof ScrollTrigger.clearScrollMemory === 'function') {
        ScrollTrigger.clearScrollMemory('manual');
      }
      try {
        for (var i = sessionStorage.length - 1; i >= 0; i--) {
          var k = sessionStorage.key(i);
          if (k && k.indexOf('gsap') === 0) sessionStorage.removeItem(k);
        }
      } catch (e) {}
    }

    limpiarMemoria();
    window.scrollTo(0, 0);

    var arranque = Date.now();
    (function pegarArriba() {
      if (Date.now() - arranque > RETENCION) {
        limpiarMemoria();
        if (window.ScrollTrigger) ScrollTrigger.refresh();
        return;
      }
      if (window.pageYOffset !== 0) window.scrollTo(0, 0);
      requestAnimationFrame(pegarArriba);
    })();

    window.addEventListener('load', function () {
      limpiarMemoria();
      window.scrollTo(0, 0);
      if (window.ScrollTrigger) ScrollTrigger.refresh();
    });

    window.addEventListener('pageshow', function (ev) {
      if (!ev.persisted) return;
      limpiarMemoria();
      window.scrollTo(0, 0);
    });

    window.addEventListener('beforeunload', limpiarMemoria);
  }

  /* ======================================================================
     TAMAÑO DEL PLANETA
     ====================================================================== */
  var intentos = 0;
  var reloj = setInterval(function () {
    intentos++;
    if (window.HUMO_HERO && window.HUMO_HERO.config) {
      clearInterval(reloj);
      if (!movil()) window.HUMO_HERO.config.planeta.escritorio = PLANETA_ESCRITORIO;
      window.dispatchEvent(new Event('resize'));
      if (!CON_ANCLA) window.scrollTo(0, 0);
    } else if (intentos > 80) {
      clearInterval(reloj);
    }
  }, 100);
})();
